import { Box, Grid, Collapse, Card } from "@mui/material";
import ActiveFilters from "../../../Components/filters/ActiveFilters";
import FilterItems from "./FilterItems";

const Filter = ({
  filterOpen,
  filterData,
  handleChangeFilter,
  handleFilter,
  handleClearFilters,
  handleRemove,
  submittedData,
}) => {
  const activeFilterDefinitions = [
    {
      type: "standard",
      id: "isNotified",
      label: "Is Notified",
      value: submittedData.isNotified,
    },
    {
      type: "dateRange",
      id: "notifiedDate",
      label: "Notified Date",
      startValue: submittedData.notifiedDateStart,
      endValue: submittedData.notifiedDateEnd,
      startField: "notifiedDateStart",
      endField: "notifiedDateEnd",
    },
    {
      type: "standard",
      id: "isCustomTemplate",
      label: "Is Custom Template",
      value: submittedData.isCustomTemplate,
    },
  ];

  const handleRemoveDateRange = (field) => {
    handleRemove(field);
  };

  return (
    <Grid item xs={12} sx={{ mb: 2 }}>
      <Collapse in={filterOpen}>
        <Card>
          <Box p={4}>
            <FilterItems
              filterData={filterData}
              handleChangeFilter={handleChangeFilter}
              handleFilter={handleFilter}
              handleClearFilters={handleClearFilters}
            />
          </Box>
        </Card>
      </Collapse>

      <ActiveFilters
        filterDefinitions={activeFilterDefinitions}
        onRemoveDateRange={handleRemoveDateRange}
        onRemoveFilter={handleRemove}
      />
    </Grid>
  );
};

export default Filter;
